<footer class="bg-primary w-100 py-3 footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-6 col-md-4 col-lg-4 col-xl-1 mb-3 mb-xl-0">
        <img src="/assets/img/logo-login.png" class="d-block d-lg-none" width="50%" alt="logo alelo">
        <img src="/assets/img/logo-login.png" class="d-none d-lg-block d-xl-none" width="34%" alt="logo alelo">
        <img src="/assets/img/logo-login.png" class="d-none d-xl-block" width="90%" alt="logo alelo">
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
        <h5 class="titulo-footer">Atendimento</h5>
        <span class="paragrafo-footer">Segunda a Sexta,</span> <span class="paragrafo-footer text-bold detalhe"> das 8 às 19h</span>
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
        <h5 class="titulo-footer">E-mail</h5>
        <span class="paragrafo-footer">atendimentovt&#64;alelo.com.br</span>
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0 ps-md-5">
        <h5 class="titulo-footer">Capitais e regiões metropolitanas</h5>
        <span class="paragrafo-footer">4003-3553</span>
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
        <h5 class="titulo-footer">Outras localidades</h5>
        <p class="paragrafo-footer">4003 3553</p>
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
        <h5 class="titulo-footer">Ouvidoria</h5>
        <p class="paragrafo-footer">0800-202-6161 - Segunda a Sexta, das <span
          class="paragrafo-footer text-bold detalhe"> das 10 às 16h - exceto feriados nacionais</span></p>
      </div>
      <div class="col-12 col-md-4 col-lg-4 col-xl-3 mb-3 mb-xl-0 offset-md-8 offset-xl-0">
        <h5 class="titulo-footer clickable" (click)="openPrivacyPolicy()" (keydown.enter)="openPrivacyPolicy()">Políticas de Privacidade</h5>
      </div>
    </div>
  </div>
</footer>
